<!-- sidebar menu area start -->

<div class="cc-sidebar-header">
  <div class="logo">
    <!-- This router link would by pass any conditions specified in the GotoHome method -->
    <a [routerLink]="['/dashboard']"><img src="{{ logoUrl }}" alt="Organization Logo" /></a>
  </div>
</div>
<div class="cc-main-menu">
  <div class="cc-menu-inner">
    <nav class="navigation-panel" role="navigation">
      <div class="navigation-links">
        <ul class="cc-sidebar-menulist" id="menu">
          <!-- MENU: Home -->
          <li routerLink="/dashboard/dashboard-landing" id="home" routerLinkActive="active">
            <div class="left-nav-item">
              <em class="cc-nav-icon fas fa-home"></em>
              <span>{{'_General_Button_Home_Text_' | translate }}</span>
            </div>
          </li>
          <!-- MENU: Manage Lobby -->
          <li *ngIf="isLTLicenseEnabled$ | async" routerLink="/lobby/lobby-view" id="manage-lobby" routerLinkActive="active">
            <div class="left-nav-item">
              <em class="cc-nav-icon fas fa-couch"></em>
              <span>{{'_General_Manage_Lobby_Text_' | translate }}</span>
            </div>
          </li>
          <!-- MENU: Appointments -->
          <li *ngIf="(isACLicenseEnabled$ | async) && showAcAppointments" routerLink="/appointment/appointments" routerLinkActive="active" id="ukg-ac-appointments">
            <div class="left-nav-item">
               <em class="cc-nav-icon fa-solid fa-calendar-days"></em>
              <span>{{'_General_Appointments_Text_' | translate }}</span>
            </div>
          </li>
          <!-- MENU: Events -->
          <li *ngIf="(isACLicenseEnabled$ | async) && acClientConfiguration?.eventsEnabled && (userPermissionList?.includes(74))" 
          id="ac-event" routerLink="/appointment/manageevents" routerLinkActive="active">
            <div class="left-nav-item">
              <em class="cc-nav-icon fa-solid fa-calendar-day"></em>
              <span>{{'_General_Event_Text_' | translate }}</span>
            </div>
          </li>
          <!-- MENU: Action Center -->
          <li *ngIf="(isACLicenseEnabled$ | async) && (userPermissionList?.includes(41))" id="ac-action-center" routerLink="/appointment/actioncenter" routerLinkActive="active">
            <div class="left-nav-item action-center-tab">
              <em class="cc-nav-icon fa-solid fa-wand-magic-sparkles"></em>
              <span>{{'_General_Action_Center_Text_' | translate }}</span>
            </div>
          </li>
          <!-- MENU: Reports -->
          <li>
          <ngb-accordion #reportsAcc="ngbAccordion" [closeOthers]="true" class="cc-accordion-sidebar" *ngIf="isReportLeftMenuEnable" (panelChange)="onPanelChange($event, reportsAcc)">
            <ngb-panel id="ngb-panel-3">
              <ng-template ngbPanelTitle>
                <span class="d-flex align-items-center">
                  <div class="cc-nav-icon">
                    <i class="fas fa-chart-pie"></i>
                  </div>
                  <div class="accordion-title">{{'_General_Report_Title_Text_' | translate }}</div>
                </span>
                <span class="caret"></span>
              </ng-template>
              <ng-template ngbPanelContent class="">
                <li *ngIf="(isLTLicenseEnabled$ | async) && userPermissionList?.includes(60)" routerLink="/report/lobby-detail-view" id="lobby-activity-reports" routerLinkActive="active">
                  <div class="left-nav-item"><em class="cc-nav-icon cc-sub-icon fas fa-dot-circle"></em><span>{{'_General_Lobby_Activity_Text_' | translate }}</span></div>
                </li>
                <li *ngIf="(isLTLicenseEnabled$ | async) && userPermissionList?.includes(65)" routerLink="/report/lobby-editor" id="lobby-editor-reports" routerLinkActive="active">
                  <div class="left-nav-item"><em class="cc-nav-icon cc-sub-icon fas fa-dot-circle"></em><span>{{'_General_Lobby_Editor_Text_' | translate }}</span></div>
                </li>
                <li *ngIf="(isLTLicenseEnabled$ | async) && userPermissionList?.includes(60)" routerLink="/report/lobby-data-view" id="lobby-data-view" routerLinkActive="active">
                  <div class="left-nav-item"><em class="cc-nav-icon cc-sub-icon fas fa-dot-circle"></em><span>{{'_Report_Lobby_Export_' | translate }}</span></div>
                </li>
                <li *ngIf="(isACLicenseEnabled$ | async) && (userPermissionList?.includes(63))" id="ac-appointmnet-details"
                    routerLinkActive="active" routerLink="/appointment/reports/appt-detail-report">
                  <div class="left-nav-item">
                    <em class="cc-nav-icon cc-sub-icon fas fa-dot-circle"></em><span>
                      {{
'_General_Appointment_Details_Text_' | translate
                      }}
                    </span>
                  </div>
                </li>
                <li *ngIf="(isACLicenseEnabled$ | async) && (userPermissionList?.includes(83))" id="ac-appointment-trends"
                    routerLinkActive="active" routerLink="/appointment/reports/trend-view">
                  <div class="left-nav-item">
                    <em class="cc-nav-icon cc-sub-icon fas fa-dot-circle"></em><span>
                      {{
'_General_Appointment_Trends_Text_' | translate
                      }}
                    </span>
                  </div>
                </li>
                <li *ngIf="(isACLicenseEnabled$ | async) && (userPermissionList?.includes(64))" id="ac-campaign-summary"
                    routerLinkActive="active" routerLink="/appointment/reports/campaigns-view">
                  <div class="left-nav-item">
                    <em class="cc-nav-icon cc-sub-icon fas fa-dot-circle"></em><span>
                      {{
'_General_Campaign_Summary_Text_' | translate
                      }}
                    </span>
                  </div>
                </li>
              </ng-template>
            </ngb-panel>
          </ngb-accordion>
          </li>
          <li>
            <ngb-accordion #mainAcc="ngbAccordion" [closeOthers]="true" class="cc-accordion-sidebar" (panelChange)="onPanelChange($event, mainAcc)">
              <!-- User Management start-->
              <ngb-panel id="ngb-panel-0" *ngIf="isUserManagemenLeftMenuEnable">
                <ng-template ngbPanelTitle>
                  <span class="d-flex align-items-center">
                    <div class="cc-nav-icon">
                      <i class="fas fa-user-cog"></i>
                    </div>
                    <div class="accordion-title">{{'_Shared_App_LeftNavBar_User_Management_Text_' | translate }}</div>
                  </span>
                  <span class="caret"></span>
                </ng-template>
                <ng-template ngbPanelContent class="">
          <li *ngIf="userPermissionList?.includes(18)" routerLink="/admin/user" id="user" routerLinkActive="active">
            <div class="left-nav-item"><em
                class="cc-nav-icon cc-sub-icon fas fa-dot-circle"></em><span>{{'_General_Users_Text_' | translate }}</span></div>
          </li>
          <li *ngIf="userPermissionList?.includes(14)" routerLink="/admin/permissions" id="permission-group-management" routerLinkActive="active">
            <div class="left-nav-item"><em class="cc-nav-icon cc-sub-icon fas fa-dot-circle"></em><span>{{'_General_Permission_Groups_Text_' | translate }}</span></div>
          </li>
          </ng-template>
          </ngb-panel>
          <!-- User Management end-->
          <!-- Location & Services start-->
          <ngb-panel id="ngb-panel-1" *ngIf="isLocationServiceLeftMenuEnable">
            <ng-template ngbPanelTitle>
              <span class="d-flex align-items-center">
                <div class="cc-nav-icon">
                  <i class="fas fa-building"></i>
                </div>
                <div class="accordion-title">{{'_Shared_App_LeftNavBar_Locations_Services_Text_' | translate }}</div>
              </span>
              <span class="caret"></span>
            </ng-template>
            <ng-template ngbPanelContent class="">
              <li *ngIf="userPermissionList?.includes(UserPermissions['View Locations'])"
                routerLink="/admin/location/index" id="locations" routerLinkActive="active">
                <div class="left-nav-item"><em
                    class="cc-nav-icon cc-sub-icon fas fa-dot-circle"></em><span>{{'_General_Locations_Text_' | translate }}</span></div>
              </li>
              <li *ngIf="userPermissionList?.includes(10)"
                routerLink="/admin/product-service-categories" id="productCategories"
                routerLinkActive="active">
                <div class="left-nav-item"><em
                    class="cc-nav-icon cc-sub-icon fas fas fa-dot-circle"></em><span>{{'_General_Product_Categories_Text_' | translate }}</span></div>
              </li>
              <li *ngIf="userPermissionList?.includes(11)" routerLink="/admin/product-and-service" id="productServices"
                routerLinkActive="active">
                <div class="left-nav-item"><em class="cc-nav-icon cc-sub-icon fas fa-dot-circle"></em><span>{{'_General_Products_Services_Text_' | translate }}</span></div>
              </li>
              <li routerLink="/admin/checklist"
                *ngIf="(isLTLicenseEnabled$ | async) && (userPermissionList?.includes(49))" id="checklist"
                routerLinkActive="active">
                <div class="left-nav-item"><em
                    class="cc-nav-icon cc-sub-icon fas fa-dot-circle"></em><span>{{'_General_Checklists_Text_' | translate }}</span></div>
              </li>
            </ng-template>
          </ngb-panel>
          <!-- Location & Services end-->
          <!-- Configurations start-->
          <ngb-panel id="ngb-panel-2" *ngIf="isConfigurationLeftMenuEnable">
            <ng-template ngbPanelTitle>
              <span class="d-flex align-items-center">
                <div class="cc-nav-icon">
                  <i class="fas fa-cogs"></i>
                </div>
                <div class="accordion-title">{{'_Shared_App_LeftNavBar_Configuration_Text_' | translate }}</div>
              </span>
              <span class="caret"></span>
            </ng-template>
            <ng-template ngbPanelContent class="">
              <li *ngIf="userPermissionList?.includes(1)" routerLink="/admin/system-configuration"
                id="system-configuration" routerLinkActive="active">
                <div class="left-nav-item"><em class="cc-nav-icon cc-sub-icon fas fa-dot-circle"></em><span>{{'_General_Global_Settings_Text_' | translate }}</span></div>
              </li>
              <li *ngIf="(isACLicenseEnabled$ | async) && showAcAdministration" 
              id="ac-appointment-administration" routerLink="/appointment/administration" routerLinkActive="active" >
                <div class="left-nav-item"><em
                    class="cc-nav-icon cc-sub-icon fas fa-dot-circle"></em><span>{{'_General_Appointments_Administration_Text_' |
                    translate }}</span>
                  </div>
              </li>

              <li *ngIf="(isLTLicenseEnabled$ | async) && (userPermissionList?.includes(31))" routerLink="/admin/kiosk"
                id="kiosk" routerLinkActive="active">

                <div class="left-nav-item"><em class="cc-nav-icon cc-sub-icon fas fa-dot-circle"></em><span>{{'_General_Kiosks_Text_' | translate }}</span></div>
              </li>
              <li *ngIf="(isLTLicenseEnabled$ | async) && (userPermissionList?.includes(57))"
                routerLink="/admin/text-configuration" routerLinkActive="active">
                <div class="left-nav-item"><em class="cc-nav-icon cc-sub-icon fas fa-dot-circle"></em><span>{{'_General_Text_Messages_Text_' | translate }}</span></div>
              </li>

              <li *ngIf="(isLTLicenseEnabled$ | async) && (userPermissionList?.includes(27))"
                routerLink="/admin/global-alerts-configuration/global-alerts-configuration-grid"
                id="global-alerts-configuration" routerLinkActive="active">
                <div class="left-nav-item"><em class="cc-nav-icon cc-sub-icon fas fa-dot-circle"></em><span>{{'_General_Global_Alerts_Text_' | translate }}</span></div>
              </li>
              <li *ngIf="(isLTLicenseEnabled$ | async) && (userPermissionList?.includes(53))"
                routerLink="/admin/lwa-reasons" id="lwa-configuration" routerLinkActive="active">
                <div class="left-nav-item"><em class="cc-nav-icon cc-sub-icon fas fa-dot-circle"></em><span>{{'_General_LWA_Text_' | translate }}</span></div>
              </li>
              <li *ngIf="userPermissionList?.includes(3)" routerLink="/admin/data-import-export/data-import-export" id="user"
                routerLinkActive="active">
                <div class="left-nav-item"><em class="cc-nav-icon cc-sub-icon fas fa-dot-circle"></em><span>{{'_General_Data_Import_Export_Text_' | translate }}</span></div>
              </li>
              <li *ngIf="userPermissionList?.includes(4)" routerLink="/admin/localization" id="localization"
                routerLinkActive="active">
                <div class="left-nav-item"><em
                    class="cc-nav-icon cc-sub-icon fas fa-dot-circle"></em><span>{{'_General_Localization_Text_' | translate }}</span></div>
              </li>
            </ng-template>
          </ngb-panel>
          <!-- Configurations end-->
          
          </ngb-accordion>
          </li>
          <li *ngIf="userPermissionList?.includes(24)" routerLink="/admin/tenant" id="tenant" routerLinkActive="active">
            <div class="left-nav-item"><em class="cc-nav-icon fas fa-database"></em><span>{{'_General_Clients_Text_' | translate }}</span></div>
          </li>

        </ul>
      </div>
      <div class="quick-links">    
        <!-- <button  class="btn btn-danger" (click)="showImpersonateTransferInfoBtnClick()">
          Transfer Impersonate Assists Info Popup
        </button> -->
       
        <button  class="btn btn-primary" id="transfer-assists-quicklink" *ngIf="isImpersonateAssistOtherUser && enableUserImpersonation && enableUserImpersonationForTenant" (click)="showImpersonateTransferBtnClick()">
          {{'_General_Transfer_Assists_Text_' | translate }}
        </button>
        <br />
        <button *ngIf="showWrapUpButton && isAssisting" id="wrap-up-quicklink" class="btn btn-primary btn-check-in"
          (click)="showLobbyWrapupBtnClick()">
          {{'_General_WrapUp_Text_' | translate }}
        </button>
        <button class="btn btn-primary btn-check-in" id="check-in-quicklink" (click)="showLobbyCheckIn()" *ngIf="isLTLicenseEnabled$ | async">
          {{'_General_CheckIn_Text_' | translate }}
        </button>
        <button class="btn btn-primary btn-book-appointments btn-check-in" id="book-appointment-quicklink" (click)="goToACWebWidget()"
          *ngIf="(isACLicenseEnabled$ | async) && isAllowWidgetAppointmentsThroughPortalEnabled">
          {{'_Shared_App_LeftNavBar_Book_Appointment_Text_' | translate }}
        </button>
      </div>
    </nav>
  </div>
</div>
<app-transfer-assist-info-popup [(dialogOpened)]="transferInfoOpened" [transferFrom]="transferFrom"
  [transferAssistDetails]="transferAssistDetails"
  (cancelled)="closeTransferImpersonateAssistsInfo()"></app-transfer-assist-info-popup>
<app-transfer-impersonate-assists [(dialogOpened)]="transferOpened" (cancelled)="closeTransferImpersonateAssists()"
  (hideButton)="hideTransferButton()"></app-transfer-impersonate-assists>
<app-lobby-check-in [(dialogOpened)]="lobbyCheckInOpened" [enableTextMessages]="enableTextMessages"
  [tenantId]="tenantId" [locationId]="locationId" [locationName]="locationName" [timezoneId]="locationTimezone"
  [signInUserId]="signInUserId" (cancelled)="closeLobbyCheckIn($event)"></app-lobby-check-in>
<app-lobby-wrap-up [(dialogOpened)]="lobbyWrapUpOpened" [signInLocationId]="locationId"
  (cancelled)="closeLobbyWrapUp()"></app-lobby-wrap-up>
<!-- sidebar menu area end-->
